import React from 'react';
import { useTranslation } from 'react-i18next';
import LAdmin from '../layouts/LAdmin';
import { Helmet } from 'react-helmet';
import CAppTitle from '../../../app/components/CAppTitle';
import FAdminNotificationMonitoring from '../features/notification-monitoring/FAdminNotificationMonitoring';
import langAdminNotificationMonitoring from '../langs/langAdminNotificationMonitoring';

const PAdminNotificationMonitoring = () => {
	const { t } = useTranslation();
	return (
		<LAdmin>
			<Helmet>
				<title>IRP Admin tools - {t(langAdminNotificationMonitoring.title.tag)}</title>
			</Helmet>
			<CAppTitle title={t(langAdminNotificationMonitoring.title.tag)} id="title-admin-notification-monitoring" />
			<FAdminNotificationMonitoring />
		</LAdmin>
	);
};

export default PAdminNotificationMonitoring;
